/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      /**
       * 🔴 템플릿 기본값은 `padding: 0 12px` 이었다. 위아래 여백이 0이라
       *    셀렉트만 옆의 일반 입력칸보다 낮게 나와 "칸이 깨진 것"처럼 보였다.
       *    위아래는 inputOutlined.input 과 같은 12px, 오른쪽은 화살표 자리를 비운다.
       */
      padding: `${pxToRem(12)} ${pxToRem(32)} ${pxToRem(12)} ${pxToRem(12)} !important`,

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    /**
     * 🔴 템플릿 기본값은 `display: none` 이라 드롭다운 화살표가 안 보였다.
     *    누를 수 있는 칸인지 알 수 없어 "고장난 입력칸"으로 읽힌다. 되살린다.
     */
    icon: {
      display: "block",
    },
  },
};

export default select;
